import { render, staticRenderFns } from "./CompanyLogIcon.vue?vue&type=template&id=02301162&"
import script from "./CompanyLogIcon.vue?vue&type=script&lang=ts&"
export * from "./CompanyLogIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports